import { parseNullableValue } from '@clearverify/utils';

import {
  EmployersSimpleListQuery,
  EmployersSimpleListQueryVariables,
  useEmployersSimpleListQuery,
} from 'src/api';

import { QueryParamsVariables, useAutocompleteFieldWithQuery } from '../forms';

export const useEmployersAutocomplete = (
  paramVariables: QueryParamsVariables<
    EmployersSimpleListQuery,
    EmployersSimpleListQueryVariables
  > = {},
) => {
  return useAutocompleteFieldWithQuery(
    useEmployersSimpleListQuery,
    {
      getQueryItems: data => data?.employerList,
      ...paramVariables,
    },
    {
      getOptionLabel: option => parseNullableValue(option.displayName),
    },
  );
};
